export { default as CategoryPage, getServerSideProps } from './CategoryPage';
export { default as ArticlePage } from './ArticlePage';
